import React from 'react'

const SIZE_PRESETS = {
    xs: { barHeight: 6, labelSize: '0.7rem', gap: '0.25rem', markerWidth: 2 },
    sm: { barHeight: 8, labelSize: '0.75rem', gap: '0.3rem', markerWidth: 2 },
    md: { barHeight: 10, labelSize: '0.8rem', gap: '0.35rem', markerWidth: 2 },
    lg: { barHeight: 12, labelSize: '0.85rem', gap: '0.4rem', markerWidth: 3 },
    xl: { barHeight: 16, labelSize: '0.9rem', gap: '0.45rem', markerWidth: 3 }
};

const TimeAllocationBar = ({ timeAllowed, timeWorked, size = 'md' }) => {
    const sizePreset = SIZE_PRESETS[size] || SIZE_PRESETS.md;

    const allowedSeconds = Number(timeAllowed) || 0;
    const workedSeconds = Number(timeWorked) || 0;
    const hasAllocation = allowedSeconds > 0;
    const isOver = workedSeconds > allowedSeconds;
    const utilizationPercent = hasAllocation
        ? Math.min((workedSeconds / allowedSeconds) * 100, 100)
        : 0;
    const overtimePercent = hasAllocation && isOver
        ? ((workedSeconds - allowedSeconds) / allowedSeconds) * 100
        : 0;

    const progressContainerStyle = {
        position: 'relative',
        width: '100%'
    };

    const progressStyle = {
        height: `${sizePreset.barHeight}px`,
        // height: 7,
        borderRadius: 10,
        overflow: 'hidden'
    };

    const baseBarStyle = {
        backgroundColor: '#48BAC8',
        borderRadius: isOver ? '999px 0 0 999px' : '999px'
    };

    const overtimeBarStyle = {
        backgroundColor: '#e03131',
        borderRadius: '0 999px 999px 0'
    };

    const markerStyle = {
        position: 'absolute',
        left: hasAllocation ? '100%' : '0%',
        top: -2,
        bottom: -2,
        width: `${sizePreset.markerWidth}px`,
        backgroundColor: '#6c757d'
    };

    const timeLabelStyle = {
        fontSize: sizePreset.labelSize,
        fontWeight: 600,
        color: '#6c757d',
        minWidth: '90px',
        textAlign: 'right'
    };

    // Format seconds to HH:MM:SS
    const formatTime = (seconds) => {
        if (!seconds || isNaN(seconds)) return '00:00:00';
        const hrs = Math.floor(Math.abs(seconds) / 3600);
        const mins = Math.floor((Math.abs(seconds) % 3600) / 60);
        const secs = Math.floor(Math.abs(seconds) % 60);
        const sign = seconds < 0 ? '-' : '';
        return `${sign}${String(hrs).padStart(2, '0')}:${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
    };

    return (
        <div
            className="d-flex align-items-center"
            style={{ gap: sizePreset.gap, flexDirection: 'column' }}
        >
            <div style={progressContainerStyle} className="flex-grow-1">
                <div className="progress bg-light position-relative" style={progressStyle}>
                    <div
                        className="progress-bar"
                        role="progressbar"
                        style={{ ...baseBarStyle, width: `${utilizationPercent}%` }}
                        aria-valuenow={workedSeconds}
                        aria-valuemin="0"
                        aria-valuemax={allowedSeconds}
                    ></div>
                    {isOver && (
                        <div
                            className="progress-bar"
                            role="progressbar"
                            style={{ ...overtimeBarStyle, width: `${overtimePercent}%` }}
                        ></div>
                    )}
                    {hasAllocation && <div style={markerStyle}></div>}
                </div>
            </div>
            <span style={timeLabelStyle}>
                {hasAllocation ? formatTime(allowedSeconds) : '00:00'} / {formatTime(workedSeconds)}
            </span>
        </div>
    );
}

export default TimeAllocationBar